var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"offset-md":"4","md":"4","sm":"12"}},[_c('login-panel')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }